import React from "react";
import "../css/Footer4.css";

const Footer4 = () => {
  return (
    <footer className="footer4">

      {/* FUN BIG BRAND BLOCK */}
      <div className="f4-top">
        <h1 className="f4-logo">SHANK</h1>
        <p className="f4-tagline">Play Hard • Lift Smart • Live Bright</p>
      </div>

      {/* MAIN GRID */}
      <div className="f4-grid">

        <div className="f4-col">
          <h3>Explore</h3>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/workouts">Workout</a>
          <a href="/plans">Pricing</a>
        </div>

        <div className="f4-col">
          <h3>Programs</h3>
          <a href="/services">Services</a>
          <a href="/trainers">Trainers</a>
          <a href="/gallery">Gallery</a>
          <a href="/faqs">FAQs</a>
        </div>

        <div className="f4-col">
          <h3>Contact</h3>
          <p>📍 221B Fitness Street, NY</p>
          <p>📞 +1 800 SHANKFIT</p>
          <p>✉ hello@shankfit.com</p>
        </div>

        <div className="f4-col">
          <h3>Follow</h3>
          <div className="f4-socials">
            <a href="#">IG</a>
            <a href="#">YT</a>
            <a href="#">FB</a>
            <a href="#">TW</a>
          </div>
        </div>

      </div>

      {/* COPYRIGHT BAR */}
      <div className="f4-bottom">
        © {new Date().getFullYear()} SHANK FITNESS — Stay Funky 💛
      </div>

    </footer>
  );
};

export default Footer4;
